export default {
  primary: {
    main: '#000',
  },
  background: {
    default: '#fafafa',
  },
  common: {
    brand: '#000',
  },
  gray: {
    dark: '#888B8D',
    mediumDark: 'rgba(217, 217, 214, 0.3)',
  },
  paintworkThickness: {
    1: '#19BF0A',
    2: '#19BF0A',
    3: '#f5c412',
    4: '#DA0000',
    5: '#DA0000',
  },
  text: {
    disabled: '#888B8D',
  },
}
